import { NeutralColors } from '@fluentui/react';

import { EstimateType, Severity, IconErrorColor } from '../constants';

const SpendTextColor = '#333333';

export const getMonitoringCardStyles = (_components, { palette }) => ({
  Container: {
    display: 'flex',
    alignItems: 'center',
    padding: 16,
    boxShadow: '1px 0.3px 2px rgba(0, 0, 0, 0.108), 0px 3px 3.6px rgba(0, 0, 0, 0.132)',
    borderRadius: 4,
    margin: '16px 0px',
  },

  Content: {
    marginRight: 24,
  },

  Actions: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginLeft: 'auto',
    whiteSpace: 'nowrap',
  },

  Icon: {
    fontWeight: 400,
    fontSize: 24,
    lineHeight: '24px',
    margin: '4px 16px 4px 0px',
  },

  [`Icon-Severity-${Severity.Error}`]: {
    color: IconErrorColor,
  },

  [`Icon-Severity-${Severity.Warning}`]: {
    color: palette.orange,
  },

  [`Icon-Severity-${Severity.Recommendation}`]: {
    color: palette.themePrimary,
  },

  Message: {
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '20px',
    margin: '4px 0px',
    color: palette.neutralPrimary,
  },

  Hint: {
    fontWeight: 400,
    fontSize: 12,
    lineHeight: '16px',
    margin: '4px 0px',
    color: NeutralColors.gray120,
  },

  Estimates: {
    fontWeight: 400,
    fontSize: 12,
    lineHeight: '16px',
    margin: '4px 0px',
  },

  WeeklyEstimatesText: {
    fontWeight: 600,
    color: NeutralColors.gray120,
  },

  Estimate: {
    marginLeft: '8px',
  },

  [EstimateType.Conversions]: {
    color: palette.green,
  },

  [EstimateType.Clicks]: {
    color: palette.green,
  },

  [EstimateType.Impressions]: {
    color: palette.green,
  },

  [EstimateType.Spend]: {
    color: SpendTextColor,
  },
});
